module.exports = __webpack_public_path__ + "img/微信.36e56c3d.svg";